import moment from 'moment';

const monthLen = moment().daysInMonth();
const currentDay = moment().format('D');

const monthValueArr = [
  15.1, 32.4, 45.2, 82.3, 91.5, 111.4, 120.16, 130.26, 137.7, 142, 149.3, 155.8,
  164.1, 178.4, 198.7, 214, 228.8, 245.1, 259, 270.5, 287, 300, 315.9, 332.4,
  347.2, 360.7, 377.2, 394.1, 427.1, 439, 460,
];

const monthCatArr = [];
for (let i = 0; i < monthLen; i++) {
  if (i !== currentDay) {
    if (i % 7 !== 0) {
      monthCatArr.push({
        label: moment()
          .date(i + 1)
          .format('MMM D'),
        showLabel: '1',
      });
    } else {
      monthCatArr.push({
        label: moment()
          .date(i + 1)
          .format('MMM D'),
        showLabel: '1',
      });
    }
  } else {
    monthCatArr.push({
      vline: 'true',
      color: '#707C92',
      dashed: '1',
      linePosition: '0',
      labelPosition: '0',
    });
    monthCatArr.push({
      label: moment()
        .date(i + 1)
        .format('MMM D'),
    });
  }
}

const dayActiveArr = [];
for (let i = 1; i <= monthLen; i++) {
  const currentDay = moment().format('D');
  if (i <= currentDay) {
    if (i % 7 !== 0) {
      dayActiveArr.push({ value: monthValueArr[i - 1], anchorAlpha: '0' });
    } else {
      dayActiveArr.push({ value: monthValueArr[i - 1] });
    }
  } else {
    dayActiveArr.push({ value: null, anchorAlpha: '0' });
  }
}

const dayInActiveArr = [];
for (let i = 1; i <= monthLen; i++) {
  if (i <= currentDay) {
    dayInActiveArr.push({ value: monthValueArr[i - 1], anchorAlpha: '0' });
  } else {
    if (i % 7 !== 0) {
      dayInActiveArr.push({ value: monthValueArr[i - 1], anchorAlpha: '0' });
    } else {
      dayInActiveArr.push({ value: monthValueArr[i - 1] });
    }
  }
}

const third_chart_month = {
  chart: {
    showBorder: '0',
    showCanvasBorder: '0',
    showAlternateHGridColor: '0',
    bgColor: '#1D1B41',
    bgAlpha: '0',
    canvasBgAlpha: '0',
    baseFontSize: '13',
    baseFont: 'Nunito Sans Light',
    baseFontColor: '#FDFDFD',
    divLineThickness: '2',
    showValues: '0',
    showLegend: '0',
    toolTipBgcolor: '#484E69',
    toolTipPadding: '7',
    toolTipBorderRadius: '3',
    toolTipBorderAlpha: '30',
    tooltipBorderThickness: '0.7',
    toolTipColor: '#FDFDFD',
    paletteColors: '#FA394E, #4B53FF',
    usePlotGradientColor: '0',
    yAxisMinValue: '0',
    yAxisMaxValue: '500',
    plotFillAlpha: '100',
    drawAnchors: '1',
    anchorBgColor: '#FA394E',
    anchorBorderColor: '#FDFDFD',
    anchorRadius: '5',
    anchorBorderThickness: '1.9',
    showPlotBorder: '0',
    showToolTip: '1',
    canvasTopMargin: '75',
    canvasBottomMargin: '75',
    canvasLeftMargin: '30',
    canvasRightMargin: '30',
    labelDisplay: 'ROTATE',
    yAxisName: 'kWh',
    transposeAnimation: '1',
    labelStep: '7',
  },

  annotations: {
    groups: [
      {
        items: [
          {
            id: '2',
            type: 'text',
            text: 'Till Now:',
            align: 'left',
            font: 'Nunito Sans',
            bold: '0',
            fontSize: '12.5',
            color: '#FDFDFD',
            x: '$canvasStartX - 20',
            y: '$canvasStartY - 35',
          },
          {
            id: '3',
            type: 'text',
            text: monthValueArr[currentDay - 1].toString() + ' kWh',
            align: 'left',
            font: 'Nunito Sans',
            bold: '1',
            fontSize: '13',
            color: '#FDFDFD',
            x: '$canvasStartX + 30',
            y: '$canvasStartY - 35',
          },
          {
            id: '4',
            type: 'text',
            text: 'Predicted:',
            align: 'left',
            font: 'Nunito Sans',
            bold: '0',
            fontSize: '12.5',
            color: '#FDFDFD',
            x: '$canvasEndX - 116',
            y: '$canvasStartY - 35',
          },
          {
            id: '5',
            type: 'text',
            text: monthValueArr[monthLen - 1].toString() + ' kWh',
            align: 'left',
            font: 'Nunito Sans',
            bold: '1',
            fontSize: '13',
            color: '#FDFDFD',
            x: '$canvasEndX - 60',
            y: '$canvasStartY - 35',
          },
        ],
      },
    ],
  },

  categories: [
    {
      category: monthCatArr,
    },
  ],

  dataset: [
    {
      seriesname: null,
      data: dayActiveArr,
    },
    {
      seriesname: null,
      alpha: '20',
      data: dayInActiveArr,
    },
  ],
};

const chartConfigs3 = {
  type: 'msarea',
  className: 'fc-mssplinearea',
  id: 'mychart3',
  dataFormat: 'JSON',
  width: '100%',
  height: '300',
  dataSource: third_chart_month,
};

export default chartConfigs3;
export { third_chart_month };
